(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };

  function $(selector, root) { return (root || document).querySelector(selector); }
  function $$(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  /* ---------- Sticky header (shows when scrolling up) ---------- */
  function initHeader() {
    var header = $('.section-header.is-sticky');
    if (!header) return;
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var hide = y > lastY && y > header.offsetHeight + 50;
      header.classList.toggle('is-hidden', hide);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Drawers (menu + cart) ---------- */
  var lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusTarget = $('[data-drawer-close]', drawer);
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function initDrawers() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-drawer-open]');
      if (opener) {
        var target = document.getElementById(opener.getAttribute('data-drawer-open'));
        if (target) {
          event.preventDefault();
          openDrawer(target);
        }
        return;
      }
      var closer = event.target.closest('[data-drawer-close]');
      if (closer) {
        event.preventDefault();
        closeDrawer(closer.closest('.menu-drawer, .cart-drawer'));
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      $$('.menu-drawer.is-open, .cart-drawer.is-open').forEach(closeDrawer);
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(gallery) {
    var viewport = $('.gallery__viewport', gallery);
    if (!viewport) return;
    var slides = $$('.gallery__slide', gallery);
    var thumbs = $$('.gallery__thumb', gallery);
    var dots = $$('.gallery__dot', gallery);
    var prev = $('.gallery__arrow--prev', gallery);
    var next = $('.gallery__arrow--next', gallery);
    var current = 0;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      viewport.scrollTo({ left: slides[index].offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
    }

    function setActive(index) {
      if (index === current && thumbs.length && thumbs[index].classList.contains('is-active')) return;
      current = index;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      if (thumbs[index]) {
        var strip = thumbs[index].parentElement;
        var left = thumbs[index].offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + thumbs[index].offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: left, behavior: 'smooth' });
        }
      }
      slides.forEach(function (s, i) {
        if (i === index) return;
        var video = $('video', s);
        if (video) video.pause();
      });
    }

    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        setActive(index);
      });
    }, { passive: true });

    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    gallery.addEventListener('gallery:goto-media', function (event) {
      var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(event.detail); });
      if (i > -1) goTo(i);
    });

    setActive(0);
  }

  /* ---------- Countdown to a real end date ---------- */
  function initCountdown(bar) {
    var end = parseInt(bar.getAttribute('data-end'), 10) * 1000;
    var output = $('.countdown-bar__time', bar);
    if (!end || isNaN(end) || !output) { bar.hidden = true; return; }

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        bar.hidden = true;
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      output.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      bar.hidden = false;
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Quantity +/- ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrapper = btn.closest('.quantity');
    var input = wrapper && $('input', wrapper);
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '0', 10);
    var value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  var cartDrawer = function () { return document.getElementById('CartDrawer'); };

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function renderCartSection(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = $('[data-cart-drawer-inner]', doc);
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var countSource = $('[data-cart-item-count]', doc);
    if (countSource) updateCartCount(countSource.getAttribute('data-cart-item-count'));
  }

  function refreshCart() {
    return fetch(theme.routes.root + (theme.routes.root.slice(-1) === '/' ? '' : '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderCartSection);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function addToCart(items, button) {
    var useDrawer = theme.cartType === 'drawer' && cartDrawer();
    var payload = { items: items };
    if (useDrawer) payload.sections = 'cart-drawer';
    if (button) button.classList.add('is-loading');
    return postJSON(theme.routes.cartAdd + '.js', payload)
      .then(function (data) {
        if (!useDrawer) { window.location.href = theme.routes.cart; return; }
        renderCartSection(data.sections);
        openDrawer(cartDrawer());
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  function changeLine(line, quantity) {
    var inner = $('[data-cart-drawer-inner]');
    if (inner) inner.classList.add('is-loading');
    return postJSON(theme.routes.cartChange + '.js', { line: line, quantity: quantity, sections: 'cart-drawer' })
      .then(function (data) { renderCartSection(data.sections); })
      .catch(function () { return refreshCart(); })
      .finally(function () {
        var el = $('[data-cart-drawer-inner]');
        if (el) el.classList.remove('is-loading');
      });
  }

  function initProductForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[data-product-form]')) return;
      if (theme.cartType !== 'drawer' || !cartDrawer()) return;
      event.preventDefault();

      var button = $('[type="submit"]', form);
      var error = $('[data-form-error]', form.closest('[data-product-info]') || form);
      if (error) { error.hidden = true; error.textContent = ''; }

      var formData = new FormData(form);
      var item = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
      var properties = {};
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      });
      if (Object.keys(properties).length) item.properties = properties;
      if (formData.get('selling_plan')) item.selling_plan = Number(formData.get('selling_plan'));

      addToCart([item], button).catch(function (err) {
        if (error) {
          error.textContent = (err && (err.description || err.message)) || theme.strings.error;
          error.hidden = false;
        }
      });
    });

    // Variant dropdown: swap the variant id and refresh price/button.
    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-variant-select]');
      if (!select) return;
      var info = select.closest('[data-product-info]');
      var sectionId = info && info.getAttribute('data-section-id');
      var form = info && $('form[data-product-form]', info);
      if (!form) return;
      $('input[name="id"]', form).value = select.value;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());

      var option = select.options[select.selectedIndex];
      var mediaId = option && option.getAttribute('data-media-id');
      var gallery = info.closest('.product') && $('.gallery', info.closest('.product'));
      if (mediaId && gallery) gallery.dispatchEvent(new CustomEvent('gallery:goto-media', { detail: mediaId }));

      fetch(url.pathname + '?variant=' + select.value + '&section_id=' + sectionId, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-price]', '[data-submit]'].forEach(function (sel) {
            var fresh = $(sel, doc);
            var current = $(sel, info);
            if (fresh && current) current.outerHTML = fresh.outerHTML;
          });
        });
    });
  }

  function initCartDrawer() {
    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-line-qty]');
      if (!input) return;
      changeLine(Number(input.getAttribute('data-cart-line-qty')), Math.max(0, Number(input.value) || 0));
    });

    document.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        changeLine(Number(remove.getAttribute('data-cart-remove')), 0);
        return;
      }
      var upsell = event.target.closest('[data-upsell-add]');
      if (upsell) {
        event.preventDefault();
        addToCart([{ id: Number(upsell.getAttribute('data-upsell-add')), quantity: 1 }], upsell);
      }
      var cartLink = event.target.closest('[data-cart-link]');
      if (cartLink && theme.cartType === 'drawer' && cartDrawer()) {
        event.preventDefault();
        openDrawer(cartDrawer());
      }
    });

    // Apps (e.g. bundle apps) often fire these after adding to cart.
    ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (name) {
      document.addEventListener(name, function () { refreshCart(); });
    });
  }

  /* ---------- Fade-in on scroll ---------- */
  function initFadeIn() {
    var items = $$('.fade-in');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Review slider ---------- */
  function initReviewSlider(slider) {
    var track = $('.review-slider__track', slider);
    var slides = $$('.review-slide', slider);
    var dots = $$('.review-slider__dot', slider);
    if (!track || slides.length < 2) return;
    var current = 0;
    function goTo(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      current = i;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }, { passive: true });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) { track.classList.remove('is-dragging'); goTo(Math.round(track.scrollLeft / track.clientWidth)); }
    });
    var seconds = parseInt(slider.getAttribute('data-autoplay'), 10);
    if (seconds > 0) {
      var timer = setInterval(function () { goTo(current + 1); }, seconds * 1000);
      ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (evt) {
        slider.addEventListener(evt, function () { clearInterval(timer); }, { once: true, passive: true });
      });
    }
  }

  /* ---------- Reviews list: filter, sort, load more ---------- */
  function initReviewsList(root) {
    var wrap = $('[data-items]', root);
    if (!wrap) return;
    var items = $$('.reviews-list__item', root);
    var moreWrap = $('[data-more-wrap]', root);
    var status = $('[data-status]', root);
    var sortSelect = $('[data-sort]', root);
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 5;
    var visible = pageSize, filter = 'all', sort = 'featured';

    function render() {
      var list = items.filter(function (el) { return filter === 'all' || el.getAttribute('data-stars') === filter; });
      list.sort(function (a, b) {
        var sa = +a.getAttribute('data-stars'), sb = +b.getAttribute('data-stars');
        var ia = +a.getAttribute('data-index'), ib = +b.getAttribute('data-index');
        if (sort === 'highest') return sb - sa || ia - ib;
        if (sort === 'lowest') return sa - sb || ia - ib;
        return ia - ib;
      });
      items.forEach(function (el) { el.hidden = true; });
      list.forEach(function (el, i) { wrap.appendChild(el); el.hidden = i >= visible; });
      var shown = Math.min(visible, list.length);
      if (status) status.textContent = shown ? 'Showing ' + shown + ' reviews' : 'No reviews with this rating.';
      if (moreWrap) moreWrap.hidden = shown >= list.length;
    }

    root.addEventListener('click', function (event) {
      var f = event.target.closest('[data-filter]');
      if (f) {
        filter = f.getAttribute('data-filter'); visible = pageSize;
        $$('[data-filter]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b === f)); });
        render(); return;
      }
      var h = event.target.closest('[data-helpful]');
      if (h) {
        var on = h.getAttribute('aria-pressed') !== 'true';
        h.setAttribute('aria-pressed', String(on));
        var label = $('[data-helpful-label]', h);
        if (label) label.textContent = on ? 'Marked helpful' : 'Helpful';
        return;
      }
      if (event.target.closest('[data-more]')) { visible += pageSize; render(); }
    });
    if (sortSelect) sortSelect.addEventListener('change', function () { sort = sortSelect.value; visible = pageSize; render(); });
    render();
  }

  /* ---------- Generic swipe carousel (arrows, dots, mouse drag) ---------- */
  function initCarousel(root) {
    var track = $('[data-carousel-track]', root);
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = $$('[data-carousel-dot]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);
    if (slides.length < 2) return;

    function index() {
      var left = track.scrollLeft, best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft - left);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft - (track.clientWidth - slides[i].offsetWidth) / 2, behavior: 'smooth' });
    }
    function update() {
      var i = index();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      var maxLeft = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxLeft;
    }
    var raf = false;
    track.addEventListener('scroll', function () {
      if (raf) return; raf = true;
      requestAnimationFrame(function () { raf = false; update(); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });

    // Mouse drag (touch already swipes natively)
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || track.scrollWidth <= track.clientWidth) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) { track.classList.remove('is-dragging'); goTo(index()); }
    });
    update();
  }

  /* ---------- Autoplay videos (some browsers ignore the autoplay attribute) ---------- */
  function initAutoplay(root) {
    var videos = $$('video[autoplay]', root);
    if (!videos.length) return;
    function play(video) {
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { videos.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play(entry.target);
        else entry.target.pause();
      });
    }, { threshold: 0.25 });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* ---------- Scroll to top ---------- */
  function initScrollTop() {
    var btn = $('[data-scroll-top]');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  function initBeforeAfter(el) {
    if (el.dataset.baReady) return;
    el.dataset.baReady = '1';
    var handle = el.querySelector('.ba__handle');
    var dragging = false;
    function set(p) {
      p = Math.max(0, Math.min(100, p));
      el.style.setProperty('--pos', p + '%');
      if (handle) handle.setAttribute('aria-valuenow', Math.round(p));
    }
    function fromEvent(e) {
      var r = el.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    }
    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      el.classList.remove('is-hinting');
      if (el.setPointerCapture) el.setPointerCapture(e.pointerId);
      fromEvent(e);
    });
    el.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      el.addEventListener(t, function () { dragging = false; });
    });
    if (handle) handle.addEventListener('keydown', function (e) {
      var now = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') { set(now - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(now + 5); e.preventDefault(); }
    });
    // Nudge once when it scrolls into view so shoppers know it drags.
    if ('IntersectionObserver' in window) {
      var start = parseFloat(getComputedStyle(el).getPropertyValue('--pos')) || 50;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        el.classList.add('is-hinting');
        setTimeout(function () { set(start - 18); }, 300);
        setTimeout(function () { set(start + 18); }, 950);
        setTimeout(function () { set(start); }, 1600);
        setTimeout(function () { el.classList.remove('is-hinting'); }, 2300);
      }, { threshold: 0.6 });
      io.observe(el);
    }
  }

  function initSection(root) {
    $$('.gallery', root).forEach(initGallery);
    $$('.countdown-bar[data-end]', root).forEach(initCountdown);
    $$('[data-review-slider]', root).forEach(initReviewSlider);
    $$('[data-reviews-list]', root).forEach(initReviewsList);
    $$('[data-carousel]', root).forEach(initCarousel);
    $$('[data-before-after]', root).forEach(initBeforeAfter);
    initAutoplay(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initDrawers();
    initProductForms();
    initCartDrawer();
    initFadeIn();
    initScrollTop();
    initSection(document);
  });

  // Theme editor: re-run section scripts when a section is changed.
  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
    $$('.fade-in', event.target).forEach(function (el) { el.classList.add('is-visible'); });
  });

  window.theme.refreshCart = refreshCart;
  window.theme.openCart = function () { openDrawer(cartDrawer()); };
})();

// Theme editor: open the FAQ button when one of its rows is selected
document.addEventListener('shopify:block:select', (e) => {
  const tab = e.target.closest && e.target.closest('details.faq-tab');
  if (tab) tab.open = true;
});
